import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  HStack, Button, ButtonIcon, Text,
} from '@gluestack-ui/themed';
import { Info } from 'lucide-react-native';

const WordCountIndicator = ({
  wordcount, targetWordcount, showWordcountDialog, wordcountColor,
}) => {
  const { t } = useTranslation();
  return (
    <HStack alignItems="center">
      <Button mr="$2" variant="link" onPress={showWordcountDialog} testID="wordcount-info-button">
        <ButtonIcon as={Info} size="xs" color="$textLight500" />
      </Button>
      {targetWordcount > 0 && (
        <>
          <Text
            testID="wordcount-text-lg"
            size="xs"
            $base-display="flex"
            $sm-display="flex"
            $md-display="flex"
            $lg-display="none"
            $xl-display="none"
            color={wordcountColor}
          >
            {`${wordcount.bodyWords}/${targetWordcount}`}
          </Text>
          <Text
            testID="wordcount-text-xl"
            size="xs"
            $sm-display="none"
            $md-display="none"
            $lg-display="flex"
            $xl-display="flex"
            color={wordcountColor}
          >
            {t('student.task.composer.wordcount.words', { wordcount: wordcount.bodyWords, target: targetWordcount })}
          </Text>
        </>
      )}
    </HStack>
  );
};

export default WordCountIndicator;
